import { directusApi, PaginatedCollection } from '@/api';

export interface Log {
    id?: number;
    message: string;
    tags: string;
    type: string;
    created_at: string;
    identifier: string;
    detail: string;
}

export interface LogState {
    allLogs: Array<Log>;
    allLogsLoading: boolean;

    activeLog: Log | null;
    activeLogLoading: boolean;
    logsPerPage: number;
    logsPage: number;
    logsTotal: number;
}

const state: LogState = {
    allLogs: [],
    allLogsLoading: false,

    activeLog: {
        id: 0,
        message: '',
        tags: '',
        type: '',
        created_at: '',
        identifier: '',
        detail: '',
    },
    activeLogLoading: false,
    logsPerPage: 0,
    logsPage: 0,
    logsTotal: 0,
};

const mutations = {
    toggleAllLogsLoading(state: LogState, data: boolean) {
        state.allLogsLoading = data;
    },
    setAllLogs(state: LogState, data: PaginatedCollection) {
        state.allLogs = data.items;
        state.logsPerPage = data.perPage;
        state.logsPage = data.currentPage;
        state.logsTotal = data.totalItems;
    },
    toggleActiveLogLoading(state: LogState, data: boolean) {
        state.activeLogLoading = data;
    },
    setActiveLog(state: LogState, data: Log) {
        state.activeLog = data;
    },
};

const actions = {
    async getAll({ _, commit }: any, { search, page, }: any | null) {
        commit('toggleAllLogsLoading', true);
        let limit = 20;
        let params = '';
        if (search) {
            params += `&search=${search}`;
        }
        params += `&sort=-created_at&meta=total_count&meta=filter_count`;
        if (page) params += `&limit=20&offset=${(page - 1) * limit}`;
        let endpoint = `items/logs?${params}`;

        await directusApi('GET', endpoint)
            .then(res => {
                commit('setAllLogs', {
                    items: res.data.data,
                    perPage: limit,
                    currentPage: page,
                    totalItems: res.data.meta.filter_count,
                });
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('toggleAllLogsLoading', false);
            });

        // await directusApi('GET', `items/logs?sort=-created_at`)
        //     .then(res => {
        //         commit('setAllLogs', res.data.data);
        //     })
        //     .catch(err => {
        //         console.log(err);
        //     })
        //     .finally(() => {
        //         commit('toggleAllLogsLoading', false);
        //     });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
